"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.submitFormAnalytics = submitFormAnalytics;
exports.dismissedMaxTimesAnalytics = dismissedMaxTimesAnalytics;
exports.shownFormAnalytics = exports.hasStorageFlag = exports.setStorageFlag = exports.STORAGE_FLAG = exports.postEmail = void 0;

var _lodash = _interopRequireDefault(require("lodash"));

require("isomorphic-fetch");

var _analytics = require("../../util/analytics");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * postEmail submits a users info to our backend that does two things:
 *  - signs them up in a SendGrid email list
 *  - adds their 'reason' answer to a database
 * See https://bitbucket.org/glowforge/gf-email-subscribe-function/ for more info.
 * @param {Object} body Body to be sent to email-subscribe-function
 */
var postEmail = function postEmail(endpoint, body) {
  return fetch(endpoint, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    mode: 'cors',
    body: JSON.stringify(body)
  });
}; // Storage flag for tracking completion of mad lib


exports.postEmail = postEmail;
var STORAGE_FLAG = '_gf_mad_lib';
/**
 * Updates localStorage to track whether a user has completed the madlib.
 */

exports.STORAGE_FLAG = STORAGE_FLAG;

var setStorageFlag = function setStorageFlag() {
  if (typeof window !== 'undefined' && window.localStorage) {
    window.localStorage.setItem(STORAGE_FLAG, new Date().toString());
  }
};
/**
 * Checks if user has storage flag.
 * @returns {Boolean} True if has cookie, false if not
 */


exports.setStorageFlag = setStorageFlag;

var hasStorageFlag = function hasStorageFlag() {
  if (typeof window !== 'undefined' && window.localStorage) {
    return !!window.localStorage.getItem(STORAGE_FLAG);
  }

  return false;
};
/**
 * Function to log to analytics when form is successfully submitted.
 */


exports.hasStorageFlag = hasStorageFlag;

function submitFormAnalytics() {
  var EVENT_NAME = 'madlib_email_submitted';
  (0, _analytics.gtmEvent)(EVENT_NAME);
  (0, _analytics.fsEvent)(EVENT_NAME);
}

function dismissedMaxTimesAnalytics() {
  var EVENT_NAME = 'madlib_dismissed_max_times';
  (0, _analytics.gtmEvent)(EVENT_NAME);
  (0, _analytics.fsEvent)(EVENT_NAME);
}
/**
 * Function to log to analytics that a user was shown the form.
 * Used to differentiate traffic between new users and those that
 * have already filled out the form.
 *
 * Is limited to one call, so we don't log this event multiple times.
 */


var shownFormAnalytics = _lodash["default"].once(function () {
  var EVENT_NAME = 'madlib_email_seen';
  (0, _analytics.gtmEvent)(EVENT_NAME);
  (0, _analytics.fsEvent)(EVENT_NAME);
});

exports.shownFormAnalytics = shownFormAnalytics;